/* tslint:disable */
export var icon = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"11\" height=\"12\"><path fill=\"currentColor\" d=\"M1.52.155L9.7 5.146a1 1 0 010 1.707l-8.18 4.991A1 1 0 010 10.991V1.009A1 1 0 011.52.155zM1.01 1.203v9.594L9.08 6 1.009 1.203z\"/></svg>\n";
//# sourceMappingURL=play.svg.js.map